<section1 sectionIcon="delivery"
          [isCurrent]="isCurrent"
          [sectionTitle]="'Delivery'">


    <ng-form #stepForm="ngForm"
             sectionBody>
        <p class="p1 m-b-6 m-t-10 m-t-9-s">{{'How do you want to receive your items?' | translate}}</p>

        <button type="button"
                (click)="selectShipping()"
                class="left p-t-2 p-b-4 p-l-3 p-r-4 bg-col-51 w-12 flex flex-middle m-b-2 m-b-3-s m-b-3-m">
            <i class="icon-delivery checkout-delivery-selection-icon"></i>
            <span class="p-l p-t-1 flex-column flex-justify-between">
                <div class="s1">
                    {{'Delivery' | translate}}
                </div>
                @if (methodsLabel) {
                <p class="w-12 p2 col-11">
                    {{'Have your items delivered' | translate}}
                </p>
                }
            </span>
        </button>

        <button type="button"
                [disabled]="disableCollection"
                (click)="selectCollection()"
                class="left p-t-4 p-b-3 p-l-3 p-r-4 bg-col-51 w-12 flex flex-middle m-b-0-s"
                [ngClass]="{'m-b-3': !disableCollection}">
            <i class="icon-collection checkout-delivery-selection-icon"></i>
            <div class="p-l p-b-1 flex-column flex-justify-between">
                <div class="s1">
                    {{'Collection' | translate}}
                </div>
                <p class="p2 col-11 w-12">
                    {{'Collect your items from your local store' | translate}}
                </p>
            </div>
        </button>
        @if(disableCollection) {
        <p class="p2 col-2">*{{'Collection not available when assembly has been selected' | translate}}.</p>
        }

        <input-wrap>
            <input type="hidden"
                   [(ngModel)]="deliveryType"
                   name="deliveryTpe"
                   required>
        </input-wrap>
    </ng-form>
</section1>
